import { AnalyticsService } from '../../typescript/common/analytics-service';

(function accordionEvents() {
  // Bind click events to all accordions on page
  if (document.getElementsByClassName('accordion-block').length > 0) {
    class AccordionBlock {
      public init() {
        const accordionItems = document.getElementsByClassName('analytics-tracking-accordion');
        for (let i = 0; i < accordionItems.length; i += 1) {
          accordionItems[i].addEventListener('click', () => {
            if (accordionItems[i].getElementsByTagName('button')[0].classList.contains('collapsed')) {
              AnalyticsService.addEvent(AnalyticsService.Accordion, accordionItems[i].getElementsByTagName('button')[0].textContent ?? '', document.URL);
            }
          });
        }
      }
    }
    const page = new AccordionBlock();
    page.init();
  }
})();
